<!-- app-subdomain-creators/src/Components/CreatorChatLinkPreview.vue -->
<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    class="block w-full 2xl:w-[500px] rounded-xl border border-zinc-200 bg-zinc-50 mt-2 shadow-sm hover:bg-zinc-100 transition"
  >
    <!-- flex row so the left column can be full-height -->
    <div class="flex items-stretch">
      <!-- LEFT: icon stripe -->
      <div
        class="flex items-center justify-center w-11 bg-zinc-100 border-r border-zinc-200 rounded-l-xl"
      >
        <LinkIcon class="w-5 h-5 text-zinc-500" />
      </div>

      <!-- RIGHT: avatar + title + time -->
      <div class="flex items-center justify-between flex-1 min-w-0 px-3 py-4">
        <!-- avatar + text -->
        <div class="flex items-center gap-3 min-w-0">
          <!-- sender avatar -->
          <div class="flex items-center justify-center w-8 h-8 rounded-full bg-zinc-200 overflow-hidden">
            <img
              v-if="avatarSrc"
              :src="avatarSrc"
              alt=""
              class="w-full h-full object-cover"
            />
          </div>

          <!-- text block -->
          <div class="flex flex-col min-w-0">
            <!-- hostname (small, optional) -->
            <!-- <div class="text-[11px] uppercase tracking-wide text-zinc-400">
              {{ displayHostname }}
            </div> -->

            <!-- main label (title or hostname) -->
            <div class="text-sm font-semibold text-zinc-800 truncate">
              {{ title || displayHostname }}
            </div>
          </div>
        </div>

        <!-- date/time -->
        <div
          v-if="createdAtLabel"
          class="ml-3 text-xs text-zinc-400 whitespace-nowrap"
        >
          {{ createdAtLabel }}
        </div>
      </div>
    </div>
  </a>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { LinkIcon } from '@heroicons/vue/24/outline';

const defaultAvatarSrc = require('@/assets/media/images/default-avatar.png');

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  createdAt: {
    type: [String, Number, Date],
    default: null,
  },
  // 'creator' | 'member' | null
  senderType: {
    type: String,
    default: null,
  },
  creatorAvatarSrc: {
    type: String,
    default: '',
  },
  memberAvatarSrc: {
    type: String,
    default: '',
  },
});

const displayHostname = computed(() => {
  try {
    const u = new URL(props.url);
    return u.hostname.replace(/^www\./, '');
  } catch (e) {
    return props.url;
  }
});

const createdAtLabel = computed(() => {
  if (!props.createdAt) return '';
  const d = new Date(props.createdAt);
  if (Number.isNaN(d.getTime())) return '';

  // 06/26 7:28 PM style
  return d.toLocaleString(undefined, {
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
});

const avatarSrc = computed(() => {
  // prefer real sender if we have it
  if (props.senderType === 'member') {
    return props.memberAvatarSrc || props.creatorAvatarSrc || defaultAvatarSrc;
  }
  if (props.senderType === 'creator') {
    return props.creatorAvatarSrc || props.memberAvatarSrc || defaultAvatarSrc;
  }

  // fallback: show the other participant first
  return props.memberAvatarSrc || props.creatorAvatarSrc || defaultAvatarSrc;
});
</script>





<style></style>
